export default __webpack_public_path__ + "static/media/caret-down.fcdd6a4a.svg";